// import React, { useState } from "react";

// function DateRangeReport({ field, onChange }) {
//   const [start, setStart] = useState();
//   const [end, setEnd] = useState();

//   function _onChange(startDate, endDate) {
//     startDate.setHours(5, 0, 0, 0); // Set start time to 5:00 AM
//     endDate.setHours(4, 59, 59, 999); // Set end time to 4:59 AM on the next day
//     endDate.setDate(endDate.getDate() + 1); // Move end date to the next day
//     const where = {};
//     where[field] = {
//       $gte: startDate.toISOString(),
//       $lte: endDate.toISOString(),
//     };
//     onChange(where);
//   }

//   function _onChangeStart(date) {
//     setStart(date.toISOString().slice(0, 10));
//     end && _onChange(date, new Date(end));
//   }

//   function _onChangeEnd(date) {
//     setEnd(date.toISOString().slice(0, 10));
//     start && _onChange(new Date(start), date);
//   }

//   return (
//     <div className="d-flex flex-column flex-md-row gap-1">
//       <input
//         className="form-control form-control-md shadow-none"
//         value={start}
//         onInput={(e) => _onChangeStart(e.target.valueAsDate)}
//         type="date"
//         placeholder="Start Date"
//       />
//       <input
//         className="form-control form-control-md shadow-none"
//         value={end}
//         onInput={(e) => _onChangeEnd(e.target.valueAsDate)}
//         type="date"
//         placeholder="End Date"
//       />
//     </div>
//   );
// }

// export default DateRangeReport;
import React, { useState } from "react";

function DateRangeReport({ field, onChange }) {
  const [start, setStart] = useState();
  const [end, setEnd] = useState();

  function _onChange(startDate, endDate) {
    startDate.setHours(5, 0, 0, 0); // Set start time to 5:00 AM
    endDate.setHours(4, 59, 59, 999); // Set end time to 4:59 AM on the next day
    endDate.setDate(endDate.getDate() + 1); // Move end date to the next day
    const where = {};
    where[field] = {
      $gte: startDate.toISOString(),
      $lte: endDate.toISOString(),
    };
    onChange(where);
  }

  function _onChangeStart(date) {
    setStart(date.toISOString().slice(0, 10));
    end && _onChange(date, new Date(end));
  }

  function _onChangeEnd(date) {
    setEnd(date.toISOString().slice(0, 10));
    start && _onChange(new Date(start), date);
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap: "12px",
        alignItems: "center",
        flexWrap: "wrap",
      }}
    >
      <div
        style={{ position: "relative", flex: "1 1 200px", minWidth: "200px" }}
      >
        <label
          style={{
            display: "block",
            fontSize: "0.875rem",
            fontWeight: 500,
            color: "#374151",
            marginBottom: "6px",
            fontFamily: "Inter, sans-serif",
          }}
        >
          Start Date
        </label>
        <div style={{ position: "relative" }}>
          <span
            style={{
              position: "absolute",
              left: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#6b7280",
              pointerEvents: "none",
              fontSize: "1rem",
            }}
          >
            <i className="bi bi-calendar3"></i>
          </span>
          <input
            className="form-control shadow-none"
            value={start}
            onInput={(e) => _onChangeStart(e.target.valueAsDate)}
            type="date"
            placeholder="Start Date"
            style={{
              height: "38px",
              paddingLeft: "40px",
              paddingRight: "12px",
              border: "1px solid #d1d5db",
              borderRadius: "8px",
              fontSize: "0.9rem",
              fontFamily: "Inter, sans-serif",
              transition: "all 0.2s ease",
              backgroundColor: "#ffffff",
            }}
            onFocus={(e) => {
              e.target.style.borderColor = "#1F4D2C";
              e.target.style.boxShadow = "0 0 0 3px rgba(31, 77, 44, 0.1)";
            }}
            onBlur={(e) => {
              e.target.style.borderColor = "#d1d5db";
              e.target.style.boxShadow = "none";
            }}
          />
        </div>
      </div>

      {/* <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "28px",
        }}
      >
        <i
          className="bi bi-arrow-right"
          style={{
            color: "#9ca3af",
            fontSize: "1.2rem",
          }}
        ></i>
      </div> */}

      <div
        style={{ position: "relative", flex: "1 1 200px", minWidth: "200px" }}
      >
        <label
          style={{
            display: "block",
            fontSize: "0.875rem",
            fontWeight: 500,
            color: "#374151",
            marginBottom: "6px",
            fontFamily: "Inter, sans-serif",
          }}
        >
          End Date
        </label>
        <div style={{ position: "relative" }}>
          <span
            style={{
              position: "absolute",
              left: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#6b7280",
              pointerEvents: "none",
              fontSize: "1rem",
            }}
          >
            <i className="bi bi-calendar3"></i>
          </span>
          <input
            className="form-control shadow-none"
            value={end}
            onInput={(e) => _onChangeEnd(e.target.valueAsDate)}
            type="date"
            placeholder="End Date"
            style={{
              height: "38px",
              paddingLeft: "40px",
              paddingRight: "12px",
              border: "1px solid #d1d5db",
              borderRadius: "8px",
              fontSize: "0.9rem",
              fontFamily: "Inter, sans-serif",
              transition: "all 0.2s ease",
              backgroundColor: "#ffffff",
            }}
            onFocus={(e) => {
              e.target.style.borderColor = "#1F4D2C";
              e.target.style.boxShadow = "0 0 0 3px rgba(31, 77, 44, 0.1)";
            }}
            onBlur={(e) => {
              e.target.style.borderColor = "#d1d5db";
              e.target.style.boxShadow = "none";
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default DateRangeReport;
